export default "__VITE_ASSET__DC76jbtP__"